import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-black/50 backdrop-blur-xl border-b border-[var(--hem-border)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <span className="text-[var(--hem-needle)] text-base leading-none group-hover:rotate-12 transition-transform duration-500">
            ✦
          </span>
          <span className="font-serif-display text-xl tracking-tight">
            Hemlock<span className="text-[var(--hem-muted)]"> Labs</span>
          </span>
        </a>
      </div>
    </motion.header>
  );
};
